<template>
<div class="container-choose">
    <div class="background-choose">
    </div>
    <div class="item-choose" v-on:click="goTo('/logisdesclos')">
        <img src="../assets/imgs/ornement.png" class="img-choose" alt="">
        <div class="name-choose">.Logis des clos.</div>
        <img src="../assets/imgs/ornement.png" class="img-choose" alt="">
    </div>
    <div class="item-choose" v-on:click="goTo('/logisduchateau')">
        <img src="../assets/imgs/ornement.png" class="img-choose" alt="">
        <div class="name-choose">.Logis du chateau.</div>
        <img src="../assets/imgs/ornement.png" class="img-choose" alt="">
    </div>
     
</div>
    
</template>

<script>
import panel from '../components/Panel-appartement'
export default {
    
    name : 'Choose',
    components: {
        
    },
    metaInfo() {
        return { 
            title: "Le Logis des Clos - Le Logis du Chateau",
            meta: [
                { name: 'description', content:  'Choisissez entre deux ravissants appartements en locatoin sur AIRBNB afin de passer un séjour agréable en Normandie'},
                { property: 'og:title', content: "Le Logis des Clos - Location Normandie"},
                { property: 'og:site_name', content: 'Le Logis des Clos'},
                {property: 'og:type', content: 'website'},    
                {name: 'robots', content: 'index,follow'} 
            ]
        }
    },
    methods : {
        goTo : function(url)
        {
            this.$router.push({path : url})
        }
    }
}
</script>


<style scoped>

.container-choose{
    background-image: url('../assets/imgs/background.jpg');
    background-position: center;
    background-size: cover;
    height: 100vh;
    width: 100%;
    padding: 1rem;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content:space-around ;
}

.name-choose {

    animation: fadeIn 1s ease-in;
}

@keyframes fadeIn {
    0% {
        opacity: 0;
        margin-bottom: 5rem;
    }
    100% {
        opacity: 1;
        margin-bottom: 0;
    }
    
}

.background-choose{
    display: flex;
    flex-direction: row;
    overflow: hidden;
    transform: rotate(-45);
    position: absolute;
    top: 0;
    left: 0;
}

.background-choose--img
{
    /*background-color: url('../assets/imgs/2.jpg');*/
}



.item-choose {
    margin: auto;
    width: 25rem;
    justify-content: space-around;
    display: flex;
    flex-direction: column;
    height: 18rem;
    font-family: 'Indie Flower', cursive;
    color: white;
    text-transform: uppercase;
    font-size: 2rem;
    background-color: rgba(0, 0, 0, 0.12);
    border-radius: 1.5rem;
    border : 3px solid white;
    box-shadow: 0px 0px 14px 0px rgba(0,0,0,0.57);
    transition-duration: 0.2s;
    cursor: pointer;
}

.item-choose:hover {
    background-color: rgba(0, 0, 0, 0.24);
}

.img-choose{
    
    
    height: 25%;
    width: 100%;
}

</style>